export default __webpack_public_path__ + "static/media/stat4.27f3613f.png";